import { gql } from '@apollo/client'

const GET_SAGA_TRANSACTION_HIERARCHY = gql`
  query GetSagaTransactionHierarchy($operationId: ID!) {
    sagaTransactionHierarchy(operationId: $operationId)
  }
`

export default GET_SAGA_TRANSACTION_HIERARCHY
